import React, {useRef, useEffect} from 'react';
import css from './App.scss';
import Nav from "./components/Nav";
import Particles from 'react-particles-js';
import About from "./components/About";
import Gallery from "./components/Gallery";
import Contacts from "./components/Contacts";
import Footer from "./components/Footer";
import Menu from "./components/Menu";
import './config';
import {motion} from "framer-motion";
import { useTranslation } from 'react-i18next';

import axios from 'axios';
import CarouselHome from "./components/CarouselHome";

const App = (props) => {
    const { t, i18n } = useTranslation();

    let contactsRef = useRef();
    let aboutRef = useRef();
    let galleryRef = useRef();
    let headRef = useRef();

    const goToContacts = () => {
        contactsRef.current.scrollIntoView({behavior: 'smooth'})
    };
    const goToAbout = () => {
        aboutRef.current.scrollIntoView({behavior: 'smooth'})
    };
    const goToGallery = () => {
        galleryRef.current.scrollIntoView({behavior: 'smooth'})
    };
    const goToHead = () => {
        headRef.current.scrollIntoView({behavior: 'smooth'})
    };

    useEffect(() => {
        if (props.location?.query?.goTo === 'gallery') {
            goToGallery();
        }
    }, []);

    return (
        <div className="App" ref={headRef}>
            <div style={{position: "relative", zIndex: 2, backgroundColor: "white"}}>
                <Nav className="nav" goToAbout={goToAbout} goToGallery={goToGallery} goToContacts={goToContacts}/>

                <CarouselHome></CarouselHome>

{/*
                <motion.div variants={global.config.animations.particlesBox} initial={"initial"} animate={"animate"}>
                    <Particles className="particles__container"
                               height={css.height_particles}
                               params={{
                                   "background": {
                                       "color": {
                                           "value": "transparent",
                                       },
                                   },
                                   "particles": {
                                       "number": {
                                           "value": 80,
                                           "density": {
                                               "enable": true,
                                               "value_area": 800
                                           }
                                       },
                                       "links": {
                                           "color": "#ffffff",
                                           "distance": 150,
                                           "enable": true,
                                           "opacity": 0.4,
                                           "width": 1,
                                       },
                                       "color": {
                                           "value": "#ffffff"
                                       },
                                       "shape": {
                                           "type": "circle",
                                           "stroke": {
                                               "width": 0,
                                               "color": "#000000"
                                           },
                                           "polygon": {
                                               "nb_sides": 5
                                           },
                                           "image": {
                                               "src": "img/github.svg",
                                               "width": 100,
                                               "height": 100
                                           }
                                       },
                                       "opacity": {
                                           "value": 0.4008530152163807,
                                           "random": false,
                                           "anim": {
                                               "enable": false,
                                               "speed": 1,
                                               "opacity_min": 0.1,
                                               "sync": false
                                           }
                                       },
                                       "size": {
                                           "value": 3,
                                           "random": true,
                                           "anim": {
                                               "enable": false,
                                               "speed": 40,
                                               "size_min": 0.1,
                                               "sync": false
                                           }
                                       },
                                       "line_linked": {
                                           "enable": true,
                                           "distance": 150,
                                           "color": "#ffffff",
                                           "opacity": 0.3687847739990702,
                                           "width": 0.6413648243462091
                                       },
                                       "move": {
                                           "enable": true,
                                           "speed": 3,
                                           "direction": "none",
                                           "random": false,
                                           "straight": false,
                                           "out_mode": "out",
                                           "bounce": false,
                                           "attract": {
                                               "enable": false,
                                               "rotateX": 600,
                                               "rotateY": 1200
                                           }
                                       }
                                   },
                                   "interactivity": {
                                       "detect_on": "window",
                                       "events": {
                                           "onhover": {
                                               "enable": true,
                                               "mode": "bubble"
                                           },
                                           "onclick": {
                                               "enable": true,
                                               "mode": "push"
                                           },
                                           "resize": true
                                       },
                                       "modes": {
                                           "grab": {
                                               "distance": 400,
                                               "line_linked": {
                                                   "opacity": 1
                                               }
                                           },
                                           "bubble": {
                                               "distance": 100,
                                               "size": 5,
                                               "duration": 2,
                                               "opacity": 8,
                                               "speed": 2
                                           },
                                           "repulse": {
                                               "distance": 100,
                                               "duration": 0.4
                                           },
                                           "push": {
                                               "particles_nb": 4
                                           },
                                           "remove": {
                                               "particles_nb": 2
                                           }
                                       }
                                   },
                                   "retina_detect": true
                               }}/>
                </motion.div>
*/}


                {/*<div className="banner__content">
                    <div>
                        <h2 className="banner__text first__text">{t('bannerText1')},</h2>
                        <h2 className="banner__text second__text">{t('bannerText2')}</h2>
                    </div>
                    <motion.div className="banner__container--button" variants={global.config.animations.buttonBanner} initial={"initial"} animate={"animate"}>
                        <div className="btn__primary" onClick={goToContacts}>
                            <div className="btn__primary--background"></div>
                            <div className="btn__primary--text">
                                <div>{t('contactUs')}</div>
                            </div>
                        </div>
                    </motion.div>
                </div>*/}

                <About forwardedRef={aboutRef}/>

                <svg viewBox="0 0 10 10" preserveAspectRatio="none" className="triangle__right">
                    <defs>
                        <linearGradient id="gradient">
                            <stop offset="5%" stopColor="#001845"/>
                            <stop offset="95%" stopColor="#023E7D"/>
                        </linearGradient>
                    </defs>
                    <polygon fill="url(#gradient)" points="10 0 10 10 0 10"/>
                    <polygon fill="white" points="0 0 10 0 0 10"/>
                </svg>
                <Gallery forwardedRef={galleryRef}/>
                <svg viewBox="0 0 10 10" preserveAspectRatio="none" className="triangle__left">
                    <defs>
                        <linearGradient id="gradient">
                            <stop offset="5%" stopColor="#001845"/>
                            <stop offset="95%" stopColor="#023E7D"/>
                        </linearGradient>
                    </defs>
                    <polygon fill="white" points="10 0 10 10 0 10"/>
                    <polygon fill="url(#gradient)" points="0 0 10 0 0 10"/>
                </svg>

                <Contacts forwardedRef={contactsRef}/>
            </div>


            <Footer goToAbout={goToAbout} goToGallery={goToGallery} goToContacts={goToContacts} goToHead={goToHead}/>
        </div>
    );
};

export default App;
